module.exports = __webpack_public_path__ + "media/images/flags/64/Saint-Vincent-and-the-Grenadines-06430492fb3bba1c06c621c7ee818b7e.png";